<template>
    <div id="job-detail">
        <header-section :subnav_show="false" :change_color="true"></header-section>
        <div class="jobdetail-wrap">
            <div class="maincon margin-0-auto">
                <div class="line-height-50 sitemap"><i class="el-icon-guide"></i> 当前位置: 人才招聘 / 职位详情</div>
                <div class="detail-top">
                    <div class="float-left cb-m-t-10">
                        <p class="cb-m-t-10 cb-f-28">
                            {{ jobDetail.jobName }}
                            <span class="cb-m-l-24 salaryColor">
                                {{ jobDetail.jobSalary }}
                            </span>
                        </p>
                        <p class="cb-m-t-10"><i class="bx bx-time-five"></i>
                            {{ formatDate(jobDetail.publishDate) }}
                        </p>
                        <p class="cb-m-t-10">
                            {{ jobDetail.workPlace }} ·
                            {{ jobDetail.education }} ·
                            {{ jobDetail.jobExperiences }}
                        </p>
                        <p class="cb-m-t-10">{{ jobDetail.jobRequirement }}</p>

                    </div>
                    <div class="cb-f-r">
                        <p class="cb-m-t-50 cb-m-b-18">
                            <span class="job-tag2 cb-dis-inlineblock cb-lineheight-40 cb-m-r-10 cb-pointer collection">
                                <i class="bx bx-mail-send"></i> 简历投送邮箱
                            </span>
                        </p>
                        <!-- 职位状态操作处理 START -->
                        <span class="btn-apply">hr@createc.cn</span>
                        <!-- 职位状态操作处理 END -->
                    </div>
                </div>
                <div class="detail-main cb-m-b-40">
                    <div class="float-left job-left">
                        <!-- 右侧不显示时显示下边 -->
                        <!-- <div class="float-left job-left" style="width: auto;border: 0;"> -->
                        <div class="title"><span><i class="iconfont icon-zhize"></i> 职责描述</span></div>
                        <div class="job-info" v-html="jobDetail.responsibility"></div>
                        <div class="title"><span><i class="iconfont icon-duiwairenzhi"></i> 任职要求</span></div>
                        <div class="job-info" v-html="jobDetail.capacity"></div>
                        <div class="title"><span><i class="iconfont icon-dizhi-01"></i> 工作地址</span></div>
                        <div class="job-info" v-html="jobDetail.workPlace">
                        </div>
                        <div class="title"><span><i class="iconfont icon-dizhi-01"></i> 福利待遇</span></div>
                        <div class="job-info" v-html="jobDetail.jobWelfare">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- footer -->
        <footer-section></footer-section>
    </div>
</template>
<script>
import HeaderSection from "@/components/public/head.vue"
import FooterSection from "@/components/public/footer.vue"
export default {
    components: {
        HeaderSection,
        FooterSection
    },
    props: {},
    data() {
        return {
            jobId: 0,
            jobDetail: {},
        };
    },
    watch: {
    },
    computed: {
    },
    methods: {
        //动态修改浏览器标题
        setBrowserTitle(title) {
            document.title = title;
        },
        //动态添加meta标签 keywords content
        addMetaKeyWords (keywords) {
            let m = document.querySelectorAll('meta');
            for(let i=0;i<m.length;i++){
                if(m[i].content ==keywords){
                    m[i].remove()
                }
            }
            const meta = document.createElement('meta')
            meta.name = 'keywords'
            meta.content = keywords
            document.head.appendChild(meta)
            
        },
        getJobDetail() {
            this.$get(this.$api.getJobDetail + "/" + this.jobId).then(response => {
                if (response.code === 0) {
                    this.jobDetail = response.data;
                    this.setBrowserTitle(response.data.jobName)
                    this.addMetaKeyWords(response.data.jobName)
                    this.loading = false
                } else {
                    window.console.log(response.msg);
                }
            });
        },
        formatDate(value) { // 时间戳转换日期格式方法
            if (value == null) {
                return ''
            } else {
                const date = new Date(value)
                const y = date.getFullYear()// 年
                let MM = date.getMonth() + 1 // 月
                MM = MM < 10 ? ('0' + MM) : MM
                let d = date.getDate() // 日
                d = d < 10 ? ('0' + d) : d
                return y + '-' + MM + '-' + d
            }
        }
    },
    created() {
        this.jobId = this.$route.params.id;
        if (this.$isEmpty(this.jobId)) {
            return this.$message.error('请检查信息是否存在');
        }
        this.getJobDetail();
    },
    mounted() {
    },
    destroyed(){
        document.title='河北科瑞达仪器科技股份有限公司-官方网站'
    }
};
</script>
<style scoped>
/*job-detail*/
.jobdetail-wrap {
    width: 100%;
    background: url(~@/static/img/bg/bg-jobdetail.png) center top no-repeat;
    background-size: 100% 350px;
}

.jobdetail-wrap .maincon .detail-top {
    width: 1175px;
    min-height: 180px;
    background: url(~@/static/img/bg/bg-detail-top.png) center top no-repeat;
    background-size: 100% 100%;
    color: #fff;
    padding: 25px;
    overflow: hidden;
}

.jobdetail-wrap .maincon {
    width: 1200px;
}

.jobdetail-wrap .maincon .sitemap {
    font-size: 12px;
    color: #fff;
}

.jobdetail-wrap .maincon.jobdetail-wrap .maincon .sitemap {
    color: #fff;
}

.jobdetail-wrap .salaryColor {
    color: #f8f6f4;
}

.line-height-50 {
    line-height: 50px !important;
}

.margin-0-auto {
    margin: 0 auto;
}

.float-left {
    float: left !important;
}

.jobdetail-wrap .maincon .detail-main .job-left {
    width: 100%;
    min-height: 485px;
}

.cb-m-l-24 {
    margin-left: 24px !important;
}

.cb-m-b-30 {
    margin-bottom: 30px !important;
}

.cb-m-t-18 {
    margin-top: 18px !important;
}

.cb-f-28 {
    font-size: 28px !important;
}

.cb-m-b-20 {
    margin-bottom: 20px !important;
}

.cb-m-t-20 {
    margin-top: 20px !important;
}

.cb-m-t-10 {
    margin-top: 10px !important;
}

.cb-m-b-10 {
    margin-bottom: 10px !important;
}

.cb-m-t-4 {
    margin-top: 4px !important;
}

.iconfont {
    font-family: "iconfont" !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.cb-f-r {
    float: right !important;
}

.cb-m-b-18 {
    margin-bottom: 18px !important;
}

.cb-m-t-50 {
    margin-top: 50px !important;
}

.jobdetail-wrap .maincon .detail-top .btn-apply {
    display: inline-block;
    height: 50px;
    line-height: 50px;
    min-width: 90px;
    padding: 0 10px;
    font-size: 14px;
    background-color: #ffffff;
    color: #4095ec;
    text-align: center;
    cursor: pointer;
    border-radius: 3px;
    box-sizing: border-box;
    border-radius: 25px;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    -o-border-radius: 25px;
    -ms-border-radius: 25px;
    box-shadow: 2px 3px 4px 0 #cccccc;
    -webkit-box-shadow: 2px 3px 4px 0 #cccccc;
    -o-box-shadow: 2px 3px 4px 0 #cccccc;
    -moz-box-shadow: 2px 3px 4px 0 #cccccc;
    -ms-box-shadow: 2px 3px 4px 0 #cccccc;
    width: 280px;
    font-size: 20px;
}

.jobdetail-wrap .maincon .detail-main {
    width: 1175px;
    background: #f9f9f9;
    padding: 25px;
    overflow: hidden;
    overflow: hidden;
}

.cb-m-b-40 {
    margin-bottom: 40px !important;
}

.jobdetail-wrap .maincon .detail-main .title {
    display: inline-block;
    width: 139px;
    border-radius: 0 20px 20px 0;
    -webkit-border-radius: 0 20px 20px 0;
    -moz-border-radius: 0 20px 20px 0;
    -o-border-radius: 0 20px 20px 0;
    -ms-border-radius: 0 20px 20px 0;
    box-shadow: 2px 3px 4px 0 #cccccc;
    -webkit-box-shadow: 2px 3px 4px 0 #cccccc;
    -o-box-shadow: 2px 3px 4px 0 #cccccc;
    -moz-box-shadow: 2px 3px 4px 0 #cccccc;
    -ms-box-shadow: 2px 3px 4px 0 #cccccc;
}

.jobdetail-wrap .maincon .detail-main .title>span {
    width: 129px;
    line-height: 30px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    display: inline-block;
    background: #4095ec;
    margin: 5px 5px 5px 0;
    border-radius: 0 15px 15px 0;
    -webkit-border-radius: 0 15px 15px 0;
    -moz-border-radius: 0 15px 15px 0;
    -o-border-radius: 0 15px 15px 0;
    -ms-border-radius: 0 15px 15px 0;
}
.jobdetail-wrap .maincon .detail-main .job-info {
    line-height: 45px !important;
    margin: 30px 0 30px 30px;
}
.jobdetail-wrap .maincon .detail-main .job-info>p {
    line-height: 55px !important;
}

</style>